import React, { useEffect, useState } from "react";

const PrivacyPolicy = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(`https://servercareseebd.careseebd.com/api/v1/footer/getFooter`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.data.length) {
          setData(data?.data[0]);
        }
      });
  }, []);
  return (
    <div className=" min-h-screen mb-5 ">
      <div className=" mt-[60px] text-center font-bold text-4xl ">
        <h1>Privacy Policy</h1>
      </div>

      <div className=" text-justify mt-3" dangerouslySetInnerHTML={{ __html: data?.privacyPolicy }}></div>
    </div>
  );
};

export default PrivacyPolicy;
